import LocalizedStrings from "react-localization";

let playerInfoStrings = new LocalizedStrings({
    en: {
        whyLudareTitle1: "WHY USE",
        whyLudareTitle2: "LUDARE?",
        whyLudareDesc: "Ludare is a game subscription service meant to support indie developers based on the way you play their games.This helps players support in the ways they already love, by playing games, and developers be rewarded for doing what they like, developing and maintaining great games.",
        supportTitle1: "SUPPORT EARLY GAMES AT",
        supportTitle2: "LOW RISK",
        supportDesc: "With Ludare, you get access to a whole library that includes early-stage games at one low cost. This means that you can try and support an array of indie games just with your playtime, rather than putting $20 or $30 into a project that maybe you'll see in 5 years.",
        influenceTitle1: "INFLUENCE",
        influenceTitle2: "WHAT GAMES ARE MADE",
        influenceDesc: "By driving revenue and information on how you play to early-stage games, studios are better equipped to make their games whether they are self-published or looking to attract a publisher.",
        favoriteTitle1: "FIND YOUR NEXT",
        favoriteTitle2: "FAVORITE GAME",
        favoriteDesc: "Ludare is building the next generation of game recommendations that are based off your real play patterns. This means that you will have the newest games that you are likely to enjoy served up fresh right to you.",
    },
});

export default playerInfoStrings;